import React from "react";
import { RoleIndex } from "../../../../../../models/role";
import { Row, SelectField, byClient, byRole } from "./fields";
import { isMultiClientRole } from "../userDialogModel";

/** Role and client(s). The client decides which client types are on offer. */
const ProgramAccessSection = ({
  form,
  roles,
  clients,
  onRoleChange,
  onClientChange,
}: {
  form: any;
  roles: any[];
  clients: any[];
  onRoleChange: (role: any) => void;
  onClientChange: (client: any) => void;
}) => {
  const roleIndex = form.values.user_role?.role_index;

  return (
    <Row>
      <SelectField
        id="user_role"
        label="Role"
        form={form}
        options={roles}
        onPick={onRoleChange}
        {...byRole}
      />
      {isMultiClientRole(roleIndex) && (
        <SelectField
          id="clients"
          label="Clients"
          xs={8}
          multiple
          form={form}
          options={clients}
          {...byClient}
        />
      )}
      {roleIndex === RoleIndex.ClientUser && (
        <SelectField
          id="client"
          label="Client"
          xs={8}
          form={form}
          options={clients}
          onPick={onClientChange}
          {...byClient}
        />
      )}
    </Row>
  );
};

export default ProgramAccessSection;
